















































































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import SubmitTable from '../organisms/SubmitTestTable.vue'
import SubmitTableSp from '../organisms/SubmitTestTableSP.vue'
import { TestInfo } from '../../utils/service/KoushiSite'
import ReturnButton from '../atoms/ReturnButton.vue'
import axios from 'axios'

export type CourseInfo = {
  // 表示用のコース名
  name: string,
  nendo: number,
  // APIから返却されたコース名
  originalCourseName: string,
}

export type DataType = {
  titleName: string
  testInfo: TestInfo[],
  courseInfo: CourseInfo[],
  width: number | null,
  selectedCourseName: string | null,
}


export default Vue.extend({
  components: {
    TitleName,
    ModalPanel,
    SubmitTable,
    SubmitTableSp,
    ReturnButton,
  },
  data(): DataType {
    return {
      titleName: 'テスト提出と結果',
      testInfo: [],
      width: null,
      courseInfo: [],
      selectedCourseName: null,
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    // サーバ側の現在時刻を取得
    this.$store.dispatch('getCurrentDate')

    // 明示的に会員用情報を使うよう切り替える
    this.$store.dispatch('saveSubmitTestMemberAuth', {
      submitMemberId: this.$cookies.get('submit_member_id')
    })

    // テストの情報を取得する APIを叩く
    this.testInfo = []
    const res = await axios.get('/api/v1/submit/tests')
    this.testInfo = res.data?.datas

    // 契約中のコースの情報を取得する
    const courses: CourseInfo[] = this.testInfo
      .map(x => ({
        name: `${x.nendo}年度 ${x.course_name}コース`,
        nendo: x.nendo,
        originalCourseName: x.course_name
      }))
    const uniqCourses: CourseInfo[] = []
    for(const course of courses) {
      if (!uniqCourses.some(x => x.name === course.name)) {
        uniqCourses.push(course)
      }
    }
    this.courseInfo = uniqCourses

    if (this.courseInfo.length > 0) {
      this.selectedCourseName = this.courseInfo[this.courseInfo.length - 1].name
    }
  },
  computed: {
    isSP(): boolean {
      // width がnullだったらSP判定でfalseを返す
      return (this.width || 769) <= 768
    },
    isShowQuestionnaire(): boolean {
      // 開発環境では表示
      if (process.env.NODE_ENV === 'development') return true
      // 表示期間：2021/08/6 13:00 〜 2021/11/30 23:59
      const today = new Date(this.$store.state.currentDate)
      return new Date('2021/08/6 13:00') <= today && today <= new Date('2021/11/30 23:59')
    },
    isMultiCourse(): boolean {
      return this.courseInfo.length > 1
    },
    selectedCourse(): CourseInfo | null {
      return this.courseInfo.find(x => x.name == this.selectedCourseName) || null
    },
    memberPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/my-page`
    },
    filteredTestInfo(): TestInfo[] {
      if(this.selectedCourse) {
        return this.testInfo.filter(x => x.nendo == this.selectedCourse?.nendo && x.course_name == this.selectedCourse?.originalCourseName)
      } else {
        return this.testInfo
      }
    },
    contactPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/contact/form/`
    },
    envPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/device/#tensaku`
    }
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    },
    submit(testInfo: TestInfo) {
      this.$store.commit('SET_SUBMITTING_TEST_INFO', testInfo)
      this.$router.push('/tensaku/submit')
    },
  },
})
